/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { MoneyAmount } from './MoneyAmount';

export type DiscountLiveRateLimit = {
    /**
     * Type of limit
     */
    type: DiscountLiveRateLimit.type;
    limit: MoneyAmount;
};

export namespace DiscountLiveRateLimit {

    /**
     * Type of limit
     */
    export enum type {
        CURRENT = 'CURRENT',
        NEW = 'NEW',
        MONTHLY = 'MONTHLY',
    }


}

